export default "__VITE_ASSET__4d79d967__"